/**
 * Gérer l'intéractivité du bouton menu.
 *
 * @export
 * @class Menu
 */
export default class Menu {
    menuBtn;
    menuList;
    isOuvert = false;
    /**
     * Créer une instance de Menu.
     *
     * @param {HTMLButtonElement} menuBtn Le bouton menu.
     * @param {HTMLUListElement} menuList Les items du menu.
     * @memberof Menu
     */
    constructor(menuBtn, menuList) {
        this.menuBtn = menuBtn;
        this.menuList = menuList;
        this.ajouterListeners();
    }
    /**
     * Ajouter les listeners.
     *
     * @private
     * @memberof Menu
     */
    ajouterListeners() {
        this.menuBtn.addEventListener("click", () => { this.toggle(); });
        window.addEventListener("click", (ev) => { this.gererClickWindow(ev); });
    }
    /**
     * Ouvrir — ou fermer — le menu.
     *
     * @public
     * @memberof Menu
     */
    toggle() {
        if (this.isOuvert) {
            this.menuList.style.display = 'none';
            this.menuBtn.innerHTML = 'menu';
        }
        else {
            this.menuList.style.display = 'block';
            this.menuBtn.innerHTML = 'close';
        }
        this.isOuvert = !this.isOuvert;
    }
    /**
     * Gérer un click sur la fenêtre.
     *
     * @private
     * @memberof Menu
     * @param ev MouseEvent
     */
    gererClickWindow(ev) {
        if (!this.isOuvert) {
            return;
        }
        if (!(ev.target instanceof Node)) {
            return;
        }
        if (this.menuBtn.contains(ev.target) ||
            this.menuList.contains(ev.target)) {
            return;
        }
        this.menuList.style.display = 'none';
        this.menuBtn.innerHTML = 'menu';
        this.isOuvert = false;
    }
}
